module.exports = __webpack_public_path__ + "img/delete2.7957feec.gif";